module.exports = __webpack_public_path__ + "static/img/A44.f575c86f.jpg";